import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import { createCustomPropType, isNumeric } from '../../../../js/app/react/validators';
import AdvForm from '../../../CommonComponents/AdvForm';
import getImagePath from '../../../CommonUtils/getImagePath';
import { ChildrenWrapper, LinkButton } from '../../../CommonComponents/Button';
import { QuovoDisabledMessageModal } from '../QuovoDisabledMessage/QuovoDisabledMessageModal';

const FidelityLink = styled(LinkButton)`
  ${ChildrenWrapper} {
    display: flex;
    align-items: center;
  }

  border: 1px solid #318dea;
  color: #444444;
  padding: 24px;
  margin-top: 64px;
  width: 100%;
  border-radius: 4px;

  &:hover,
  &:focus {
    color: #318dea;
  }

  img {
    width: 148px;
    margin-right: 24px;
  }
`;

const StyledInput = styled.input({
  '&&&&::placeholder': {
    fontSize: '32px',
  },
});

const QuovoSearchInstitutionView = ({
  clientId,
  hasFidelity,
  isWaitingForResults,
  onFidelityClick,
  onManualAddAccountPressed,
  workflowId,
}) => {
  const [showQuovoMessage, setShowQuovoMessage] = useState(false);

  return (
    <div className="adv-workflow-container-outer">
      <div className="adv-workflow-container-inner">
        <div className="adv-workflow-content generic-workflow">
          <div className="step">
            <AdvForm className="accounts-workflow-link-institution-form">
              <h2 className="accounts-workflow-link-institution-h2">
                What is the name of your institution?
              </h2>
              <div
                className={`accounts-workflow-link-institution-input${
                  isWaitingForResults ? ' loading' : ''
                }`}
              >
                <div className="input-autocomplete">
                  <div className="adv-workflow-input ">
                    <StyledInput
                      type="text"
                      placeholder="Search..."
                      onKeyPress={event => {
                        event.preventDefault();
                        setShowQuovoMessage(true);
                      }}
                      onFocus={() => {
                        setShowQuovoMessage(true);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="adv-financial-accounts-manual-text">
                Or add a&nbsp;
                <button
                  onClick={onManualAddAccountPressed(workflowId)}
                  type="button"
                  className="adv-financial-accounts-manual-button"
                >
                  manual account.
                </button>
              </div>

              {hasFidelity && (
                <FidelityLink
                  onClick={() => {
                    window.open(
                      `/Consumer/FidelityAccess/GetOrionUrl?clientId=${clientId}`,
                      '_blank',
                    );
                    onFidelityClick();
                  }}
                >
                  <img src={getImagePath('fidelity-investments.png')} alt="Fidelity Investments" />
                  <div>Add a Fidelity Access account</div>
                </FidelityLink>
              )}
            </AdvForm>
            {showQuovoMessage && (
              <QuovoDisabledMessageModal onRequestClose={() => setShowQuovoMessage(false)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

QuovoSearchInstitutionView.defaultProps = {
  onFidelityClick: () => {},
  hasFidelity: false,
};

QuovoSearchInstitutionView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  hasFidelity: PropTypes.bool,
  isWaitingForResults: PropTypes.bool.isRequired,
  onFidelityClick: PropTypes.func,
  onManualAddAccountPressed: PropTypes.func.isRequired,
  workflowId: PropTypes.string.isRequired,
};

export default QuovoSearchInstitutionView;
